import { get } from 'lodash';
import React, { FC } from 'react';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { ANTRAG_TYP, ANTRAGS_FORMULAREN, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import AbschlussAntragEbusse from '../../../foerderantrag/ebusse/content/AbschlussAntragEbusse';
import AbschlussAntragEmob from '../../../foerderantrag/emob/content/AbschlussAntragEmob';
import AbschlussAntragEpz from '../../../foerderantrag/epz/content/AbschlussAntragEpz';
import AbschlussAntragKreativwirtschaft from '../../../foerderantrag/kreativwirtschaft/content/AbschlussAntragKreativwirtschaft';
import AbschlussAntragLoewe from '../../../foerderantrag/loewe/content/AbschlussAntragLoewe';
import AbschlussAntragLogMob from '../../../foerderantrag/logmob/content/AbschlussAntragLogMob';
import AbschlussMessefoerderung from '../../../foerderantrag/messefoerderung/content/AbschlussMessefoerderung';
import AbschlussAntragMobilitaetsplaene from '../../../foerderantrag/mobilitaetsplaene/content/AbschlussAntragMobilitaetsplaene';
import AbschlussAntragStartUp from '../../../foerderantrag/startupprojekte/content/AbschlussAntragStartUp';
import AbschlussAntragStipendium from '../../../foerderantrag/stipendium/content/AbschlussAntragStipendium';
import AbschlussSkizzeEmob from '../../../skizze/emob/content/AbschlussSkizzeEmob';
import AbschlussSkizzeLoewe from '../../../skizze/loewe/content/AbschlussSkizzeLoewe';
import AbschlussSkizzeLogMob from '../../../skizze/logmob/content/AbschlussSkizzeLogMob';
import AbschlussSkizzeStipendium from '../../../skizze/stipendium/content/AbschlussSkizzeStipendium';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const AbschlussAngabenPruefen: FC<{ untertitel: string; inhalt: string }> = ({ untertitel, inhalt }) => {
	const { application } = useApplication();

	const RenderUebersichtTabelle: FC<{}> = () => {
		const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');
		const antragsTyp = get(application, P.Allgemein_Typ.path, '');

		switch (antragsFormular) {
			// Alle Emob
			case ANTRAGS_FORMULAREN.EmobInvest:
			case ANTRAGS_FORMULAREN.EmobFundE:
			case ANTRAGS_FORMULAREN.EmobLis:
				if (antragsTyp === ANTRAG_TYP.Skizze) return <AbschlussSkizzeEmob />;
				return <AbschlussAntragEmob />;
			// Messeförderung
			case ANTRAGS_FORMULAREN.Messefoerderung:
				return <AbschlussMessefoerderung />;
			// Kreativwirtschaft
			case ANTRAGS_FORMULAREN.Kreativwirtschaft:
				return <AbschlussAntragKreativwirtschaft />;
			// Löwe
			case ANTRAGS_FORMULAREN.Loewe:
				if (antragsTyp === ANTRAG_TYP.Skizze) return <AbschlussSkizzeLoewe />;
				return <AbschlussAntragLoewe />;
			// Elektrobusse
			case ANTRAGS_FORMULAREN.Elektrobusse:
				return <AbschlussAntragEbusse />;
			// Logistik und Mobilität
			case ANTRAGS_FORMULAREN.LogistikUndMobilitaet:
				if (antragsTyp === ANTRAG_TYP.Skizze) return <AbschlussSkizzeLogMob />;
				return <AbschlussAntragLogMob />;
			// Mobilitätspläne
			case ANTRAGS_FORMULAREN.Mobilitaetsplaene:
				return <AbschlussAntragMobilitaetsplaene />;
			// StartUp Stipendium
			case ANTRAGS_FORMULAREN.StartUpStipendium:
				if (antragsTyp === ANTRAG_TYP.Skizze) return <AbschlussSkizzeStipendium />;
				return <AbschlussAntragStipendium />;
			// StartUp Projekte
			case ANTRAGS_FORMULAREN.StartUpProjekte:
				return <AbschlussAntragStartUp />;
			// Entwicklungszusammenarbeit
			case ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit:
				return <AbschlussAntragEpz />;
			default:
				return <></>;
		}
	};
	return (
		<>
			<ApplicationHeading title={untertitel} description={PLATZHALTER_TEXT} />
			<MarkdownRenderer markdown={inhalt} />

			<RenderUebersichtTabelle />
		</>
	);
};

export default AbschlussAngabenPruefen;
